import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Form, FormGroup, Label } from 'reactstrap';
import { change, Field, reduxForm } from 'redux-form';
import { isRequired } from '../../../../utils/validators';
import FormItem from '../../../common/forms/FormItem';
import Loader from '../../../common/Loader';
import FormFooter from '../../../common/forms/FormFooter';
import TextInput from '../../../common/forms/input/TextInput';
import DynamicForm from '../../../common/forms/DynamicForm';
import { ROUTE_SEGMENT_COLUMNS } from '../../../../config/dynamicFormFields';

export const RouteForm = ({ handleSubmit, loading, dispatchChange, edit }) => {
  if (loading) return <Loader />;

  const onClickRemove = (index, fields) => {
    fields.remove(index);
  };

  const [origin, setOrigin] = useState('');
  const [destination, setDestination] = useState('');
  const [stops, setStops] = useState('');

  useEffect(() => {
    if (!edit) {
      const routeName = `${origin.toUpperCase()} - ${destination.toUpperCase()} - ${stops}`;
      dispatchChange('RouteForm', 'name', routeName);
    }
  }, [origin, destination, stops]);

  return (
    <Form onSubmit={handleSubmit}>
      {!edit && (
        <FormGroup row>
          <div className="col-md-6 d-flex gap-2">
            <div className="col">
              <input
                type="text"
                className="form-control"
                value={origin}
                onChange={(e) => setOrigin(e.target.value)}
                placeholder="Origen"
              />
            </div>
            <div className="col">
              <input
                type="text"
                className="form-control"
                value={destination}
                onChange={(e) => setDestination(e.target.value)}
                placeholder="Destino"
              />
            </div>
            <div className="col">
              <input
                type="text"
                className="form-control"
                value={stops}
                onChange={(e) => setStops(e.target.value)}
                placeholder="Paradas"
              />
            </div>
          </div>
        </FormGroup>
      )}

      <FormGroup row>
        <FormItem label="Nombre: " required>
          <Field
            name="name"
            component={TextInput}
            placeholder="Nombre"
            validate={[isRequired]}
            disabled={!edit}
          />
        </FormItem>
      </FormGroup>
      <FormGroup row>
        <FormItem label="Descripción: " required>
          <Field
            name="description"
            component={TextInput}
            placeholder="Descripción"
            validate={[isRequired]}
          />
        </FormItem>
      </FormGroup>
      <FormGroup row>
        <FormItem>
          {!edit && (
            <>
              <Label>
                <Field name="isOneWay" component="input" type="checkbox" /> Solo
                Ida
              </Label>
              <br />
            </>
          )}
          <Label>
            <Field name="isMaciva" component="input" type="checkbox" /> Maciva
          </Label>
        </FormItem>
      </FormGroup>
      <FormGroup row>
        <FormItem label="Características">
          <Label>
            <Field name="hotZone" component="input" type="checkbox" /> Zona
            Cálida
          </Label>
          <br />
          <Label>
            <Field name="coldZone" component="input" type="checkbox" /> Zona
            Fría
          </Label>
          <br />
          <Label>
            <Field name="steepRoute" component="input" type="checkbox" /> Ruta
            Empinada
          </Label>
          <br />
          <Label>
            <Field name="flatRoute" component="input" type="checkbox" /> Ruta
            Llana
          </Label>
          <br />
          <Label>
            <Field name="isLong" component="input" type="checkbox" /> Ruta Larga
          </Label>
        </FormItem>
      </FormGroup>
      <DynamicForm
        name="routeSegmentList"
        columns={ROUTE_SEGMENT_COLUMNS}
        onClickRemove={onClickRemove}
      />
      <FormFooter />
    </Form>
  );
};

RouteForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  dispatchChange: PropTypes.func.isRequired,
  edit: PropTypes.bool,
};

RouteForm.defaultProps = {
  edit: false,
};

const mapStateToProps = ({ RouteUnit }) => ({
  loading: !RouteUnit.Route.getIn(['current', 'activity']).isEmpty(),
});

const mapDispatchToProps = {
  dispatchChange: change,
};

const formComponent = reduxForm({
  form: 'RouteForm',
})(RouteForm);

export default connect(mapStateToProps, mapDispatchToProps)(formComponent);
